import React, { useEffect, useState } from "react";
import { GetServices } from "../../hooks/useServiceData";
import { ServiceTableHeadCells } from "../../constants/ServiceConstants";
import GeneralTable from "../GeneralTable";

export const ServiceTable = (props) => {
  const [services, setServices] = useState([]);

  const { data } = GetServices();

  useEffect(() => {
    let serviceList = [];

    if (data?.data) {
      serviceList = data?.data.map((service) => {
        return {
          id: service.id,
          owner_id: service.owner_id,
          name: service.name,
          cost: service.cost,
          account: service.account.number,
          isActive: service.isActive === 1 ? "Aktiv" : "Inaktiv",
        };
      });
      setServices(serviceList);
    }
  }, [data]);

  return (
    <>
      <GeneralTable
        headCells={ServiceTableHeadCells}
        rows={services}
        handleSelect={props.handleSelect}
      />
    </>
  );
};
